<template>
  <div class="dropdown" v-if="obj.placeholder && obj.allSelects">
    <div :class="{ 'vzw-default-selects': true, 'marketing': obj.marketing }">
      <div
        :class="{ 'select-selected': true, 'open': showSelectors }"
        v-html="active"
        @click="openSelects($event)"
      ></div>
      <div class="select-items" v-if="showSelectors">
        <div
          v-for="(s, index) in obj.allSelects"
          :value="s"
          :key="`${s}${index}`"
          v-html="s"
          @click="newChoice(s)"
          :class="{ 'selected': s === active }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  props: {
    obj: Object
    // {
    //   marketing: Boolean,
    //   id: String,
    //   placeholder: String,
    //   allSelects: Array
    // }
  },
  data: function() {
    return {
      active: this.obj.placeholder,
      showSelectors: false
    };
  },
  methods: {
    openSelects: function() {
      this.showSelectors = !this.showSelectors;
    },
    newChoice: function(val) {
      console.log(val);
      this.active = val;
    }
  }
};
</script>

<style lang="scss">
.dropdown {
  .vzw-default-selects {
    border: 1px solid $gray-3;
    border-bottom-color: $black;
    font-size: 17px;
    letter-spacing: -0.45px;
    margin: 0 auto 0 0;
    max-width: 174px;
    padding: 0;
    position: relative;
    &.marketing {
      border: none;
      font-weight: 700;
      .select-selected {
        border: none;
        border-bottom: 1px solid $gray-6;
        // &.up {
        //   &:after {
        //     transform: rotate(-135deg);
        //   }
        // }
        &.selected {
          color: $black;
        }
        &.error {
          border-bottom: 3px solid $orange;
        }
      }
      .select-items {
        div {
          border-color: transparent $gray-6 rgba(0, 0, 0, 0.1) $gray-6;
          color: $gray-6;
          &:last-of-type {
            border-bottom: 1px solid $gray-6;
          }
          &.hover {
            border-left: 1px solid $gray-6;
            color: $black;
          }
        }
      }
    }
    &.complete {
    }
    &.disabled {
      opacity: 0.25;
    }
    &.locked {
      border: 1px solid transparent;
      .select-selected {
        border: none;
        &:after {
          display: none;
        }
      }
    }
    &.error {
      border-color: $orange;
      border-bottom-width: 3px;
      .select-selected {
        border-color: $orange;
      }
    }
    select {
      display: none;
    }
    .select-items {
      background-color: $white;
      color: $black;
      left: 0;
    }
    .select-items div,
    .select-selected {
      border: 1px solid transparent;
      border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
      color: $black;
      cursor: pointer;
      padding: 10px 16px;
      position: relative;
      user-select: none;
      &.hover {
        border-left: 4px solid $black;
        padding: 10px 16px 10px 12px;
      }
      &.selected {
        border-left: 4px solid $red;
        padding: 10px 16px 10px 12px;
      }
      &.disabled {
        opacity: 0.25;
      }
    }
    .select-selected {
      background-color: $white;
      border-bottom: 2px solid $black;
      color: $black;
      &:after {
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        content: "";
        display: inline-block;
        height: 8px;
        position: absolute;
        right: 15px;
        transform: rotate(45deg);
        width: 8px;
      }
      &.open {
        &:after {
          top: 39%;
          transform: rotate(-135deg);
        }
      }
    }
    .select-hide {
      display: none;
    }
    .select-items div:hover,
    .same-as-selected {
      border-left: 4px solid $black;
      padding-left: 12px;
    }
  }
}
</style>
